class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);



/* upsell product */


//   document.addEventListener('DOMContentLoaded', () => {
//     const carouselSelector = '#upsell-carousel';

//     // function initCarousel() {
//     //   const $carousel = $(carouselSelector);
//     //   if (!$carousel.length) return;

//     //   if (!$carousel.hasClass('owl-loaded')) {
//     //     $carousel.owlCarousel({
//     //       items: 2,
//     //       nav: false,
//     //       loop: false,
//     //       autoplay: true,
//     //       autoplayTimeout: 7000,
//     //       autoplayHoverPause: true
//     //     });
//     //   } else {
//     //     $carousel.trigger('refresh.owl.carousel');
//     //   }
//     // }

//     function refreshCartDrawer(callback) {
//       fetch(`${routes.cart_url}?section_id=cart-drawer`)
//         .then(res => res.text())
//         .then(htmlText => {
//           const parser = new DOMParser().parseFromString(htmlText, 'text/html');
//           const selectors = ['cart-drawer-items', '.cart-drawer__footer'];

//           selectors.forEach(selector => {
//             const newEl = parser.querySelector(selector);
//             const oldEl = document.querySelector(selector);
//             if (newEl && oldEl) oldEl.replaceWith(newEl);
//           });

//           if (typeof callback === 'function') callback();
//         });
//     }

//     function getCartProductIds() {
//       return fetch('/cart.js')
//         .then(res => res.json())
//         .then(data => data.items.map(item => item.product_id));
//     }


// function restoreUpsells() {
//   getCartProductIds().then(cartIds => {
//     const $carousel = $(carouselSelector).data('owl.carousel');
//     const wrapper = document.querySelector('.upsell-products-wrapper');
//     if (!$carousel) return;

//     let addedCount = 0;

//     const currentUpsellIds = Array.from(document.querySelectorAll(`${carouselSelector} .upsell-product`))
//       .map(el => parseInt(el.dataset.productId));

//     document.querySelectorAll('#upsell-product-templates .upsell-product').forEach(template => {
//       const productId = parseInt(template.dataset.productId);

//       const isInCart = cartIds.includes(productId);
//       const isDuplicate = currentUpsellIds.includes(productId);

//       if (!isInCart && !isDuplicate) {
//         $carousel.add($(template.outerHTML));
//         addedCount++;
//       }
//     });

//     $carousel.refresh();
//     bindUpsellButtons();

//     // Toggle wrapper visibility
//     const items = document.querySelectorAll(`${carouselSelector} .upsell-product`);
//     if (wrapper) {
//       wrapper.classList.toggle('up_none', items.length === 0);
//     }
//   });
// }



//   function bindUpsellButtons() {
//     document.querySelectorAll(`${carouselSelector} .add-upsell`).forEach(button => {
//       button.onclick = handleAddUpsell;
//     });
//   }

//   function handleAddUpsell(e) {
//     const button = e.currentTarget;
//     const variantId = button.dataset.variantId;
//     const owlItem = button.closest('.owl-item');
//     const index = $(owlItem).index();

//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ id: variantId, quantity: 1 })
//     }).then(() => {
//       const $owl = $(carouselSelector).data('owl.carousel');
//       if ($owl && index !== -1) {
//         $owl.remove(index);
//         $owl.refresh();
//       }

//       const now = new Date();
//       console.log(`Quantity changed at: ${now.toLocaleTimeString()}`);

//       refreshCartDrawer(() => {
//         restoreUpsells();
//       });
//     });
//   }

//   function watchCartDrawerOpen() {
//     const cartDrawer = document.querySelector('cart-drawer');
//     if (!cartDrawer) return;

//     new MutationObserver(mutations => {
//       mutations.forEach(m => {
//         if (m.attributeName === 'class' && cartDrawer.classList.contains('active')) {
//           setTimeout(() => {
//             restoreUpsells();
//             // initCarousel();
//             bindUpsellButtons();
//           }, 100);
//         }
//       });
//     }).observe(cartDrawer, { attributes: true });
//   }

//   // Handle dynamic cart remove button
//   document.body.addEventListener('click', function (e) {
//     const removeBtn = e.target.closest('.cart-remove-button');
//     if (removeBtn) {
//       setTimeout(() => {
//         restoreUpsells();
//         // initCarousel();
//       }, 1000);
//     }
//   });

//   document.body.addEventListener('change', (e) => {
//     if (e.target.matches('.quantity__input')) {
//       console.log("test");
//       setTimeout(() => {
//         restoreUpsells();
//         // initCarousel();
//       }, 1000);
//     }
//   });

//   // Initial load
//   // initCarousel();
//   restoreUpsells();
//   bindUpsellButtons();
//   watchCartDrawerOpen();
// });









// before checkout

document.body.addEventListener('click', (e) => {
  const button = e.target.closest('.add-upsell');
  if (!button) return;

  const variantId = button.dataset.variantId;
  button.innerHTML = `<div class="loading__spinner"><svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg></div>`;

  // Add product to cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(() => {
      // Refresh cart drawer
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser().parseFromString(html, 'text/html');
          const newDrawer = parser.querySelector('cart-drawer');
          const oldDrawer = document.querySelector('cart-drawer');
          if (newDrawer && oldDrawer) oldDrawer.replaceWith(newDrawer);

          // Reopen the drawer with latest content
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.classList.add('active');
            document.documentElement.classList.add('overflow-hidden');
          }
        });
    })
    .catch(err => console.error('Error adding upsell:', err));
});




// document.addEventListener("DOMContentLoaded", function () {
//   // get current cart-drawer when needed (don’t cache permanently)
//   function toggleUpsell(show) {
//     const cartDrawer = document.querySelector("cart-drawer");
//     if (!cartDrawer) return;

//     const upsellWrapper = cartDrawer.querySelector(".upsell-products-wrapper");
//     const drawerHeader = cartDrawer.querySelector(".drawer__header-heading");
//     const cartItems = cartDrawer.querySelector("cart-drawer-items");
//     const beforeCheckoutBtn = cartDrawer.querySelector("#CartDrawer_Before_Checkout");
//     const checkoutBtn = cartDrawer.querySelector("#CartDrawer-Checkout");
//     const backBtn = cartDrawer.querySelector("#cartdrawer_back");

//     if (!upsellWrapper) return;

//     if (show) {
//       // Show upsell screen
//       upsellWrapper.style.display = "block";
//       if (drawerHeader) drawerHeader.style.display = "none";
//       if (cartItems) cartItems.style.display = "none";
//       if (beforeCheckoutBtn) beforeCheckoutBtn.style.display = "none";
//       if (checkoutBtn) checkoutBtn.style.display = "block";
//       if (backBtn) backBtn.style.display = "block"; // show back button on upsell screen
//     } else {
//       // Show normal cart screen
//       upsellWrapper.style.display = "none";
//       if (drawerHeader) drawerHeader.style.display = "";
//       if (cartItems) cartItems.style.display = "";
//       if (beforeCheckoutBtn) beforeCheckoutBtn.style.display = "block";
//       if (checkoutBtn) checkoutBtn.style.display = "none";
//       if (backBtn) backBtn.style.display = "none"; // hide back button on main cart
//     }
//   }

//   // Use delegated click listener so it works after AJAX replacements
//   document.body.addEventListener("click", function (e) {
//     const target = e.target.closest(
//       "#CartDrawer_Before_Checkout, #CartDrawer-Checkout, #cartdrawer_back"
//     );
//     if (!target) return;

//     // Before Checkout → show upsell
//     if (target.id === "CartDrawer_Before_Checkout") {
//       toggleUpsell(true);
//     }

//     // Checkout → hide upsell (return to normal view, then go checkout)
//     else if (target.id === "CartDrawer-Checkout") {
//       toggleUpsell(false);
//       window.location.href = "/checkout";
//     }

//     // Back button → return to normal cart screen
//     else if (target.id === "cartdrawer_back") {
//       toggleUpsell(false);
//     }
//   });

//   // Reset on AJAX cart updates
//   document.addEventListener("cart:updated", function () {
//     toggleUpsell(false);
//   });

//   // initial safe call
//   toggleUpsell(false);
// });









document.body.addEventListener("click", function (e) {
  const cartDrawer = document.querySelector("cart-drawer");
  if (!cartDrawer) return;

  const target = e.target.closest("#CartDrawer_Before_Checkout, #cartdrawer_back");
  if (!target) return;

  const upsellWrapper = cartDrawer.querySelector(".upsell-products-wrapper");
  const drawerHeader = cartDrawer.querySelector(".drawer__header-heading");
  const cartDrawerItems = cartDrawer.querySelector("cart-drawer-items");
  const checkoutBtn = cartDrawer.querySelector("#CartDrawer-Checkout");
  const beforeCheckoutBtn = cartDrawer.querySelector("#CartDrawer_Before_Checkout");
  const backBtn = cartDrawer.querySelector("#cartdrawer_back");

  // 🔙 If back button clicked → return to main cart view
  if (target.id === "cartdrawer_back") {
    if (upsellWrapper) upsellWrapper.style.display = "none";
    if (drawerHeader) drawerHeader.style.display = "flex";
    if (cartDrawerItems) cartDrawerItems.style.display = "block";
    if (checkoutBtn) checkoutBtn.style.display = "none";
    if (beforeCheckoutBtn) beforeCheckoutBtn.style.display = "block";
    if (backBtn) backBtn.style.display = "none";
    return;
  }

  // 🛒 If "Before Checkout" clicked → check upsell state
  const upsellProducts = cartDrawer.querySelectorAll(".upsell-product[data-product-id]");
  const cartItems = cartDrawer.querySelectorAll(".cart-item[data-product-id]");

  const upsellIds = Array.from(upsellProducts).map(el => Number(el.dataset.productId));
  const cartIds = Array.from(cartItems).map(el => Number(el.dataset.productId));

  // ✅ No upsells → direct checkout
  if (upsellIds.length === 0) {
    window.location.href = "/checkout";
    return;
  }

  // ✅ All upsells already in cart → direct checkout
  const allInCart = upsellIds.every(id => cartIds.includes(id));
  if (allInCart) {
    window.location.href = "/checkout";
    return;
  }

  // 💥 Otherwise → show upsell view
  if (upsellWrapper) upsellWrapper.style.display = "block";
  if (drawerHeader) drawerHeader.style.display = "none";
  if (cartDrawerItems) cartDrawerItems.style.display = "none";
  if (checkoutBtn) checkoutBtn.style.display = "block";
  if (beforeCheckoutBtn) beforeCheckoutBtn.style.display = "none";
  if (backBtn) backBtn.style.display = "block";
});
